/**
 * Created by RaoMeng on 2020/10/30
 * Desc: 拜访详情
 */

import React, { Component } from 'react'
import { getFormItems } from '../../utils/form.util'
import { List, Toast } from 'antd-mobile'
import { visitApplyBill } from '../../json/visitApplyBill'
import { isObjEmpty } from '../../utils/common'
import { fetchGet } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'

export default class VisitDetail extends Component {

  constructor () {
    super()

    this.state = {
      billGroupModelList: [],
    }
  }

  componentDidMount () {
    document.title = '拜访详情'
    this.recordId = this.props.match.params.id
    this.getVisitDetail()
  }

  componentWillUnmount () {

  }

  render () {
    const formItems = getFormItems(this.state.billGroupModelList)
    return (
      <div className='visit-apply-root' style={{ flex: 1 }}>
        <List>
          {formItems}
        </List>
      </div>
    )
  }

  getVisitDetail = () => {
    if (isObjEmpty(this.recordId)) {
      Toast.fail('单据id为空')
      return
    }
    Toast.loading('单据获取中...', 0)
    fetchGet(API.VISIT_RECORD_DETAIL + this.recordId).then(response => {
      Toast.hide()
      let resData = response.data
      if (isObjEmpty(resData)) {
        Toast.fail('数据为空')
        return
      }
      let visitBill = visitApplyBill()
      if (!isObjEmpty(visitBill)) {
        if (!isObjEmpty(visitBill[0].showBillFields)) {
          visitBill[0].showBillFields.map(item => {
            item.readOnly = 'T'
            item.allowBlank = 'T'
            if (item.field === 'name') {
              item.value = resData.name
            } else if (item.field === 'idCard') {
              item.value = resData.idCard
            } else if (item.field === 'mobile') {
              item.value = resData.mobile
            } else if (item.field === 'objectName') {
              item.value = resData.objectName
            } else if (item.field === 'visitTime') {
              item.value = resData.visitTime
            } else if (item.field === 'reason') {
              item.value = resData.reason
            }
          })
        }
      }
      this.setState({ billGroupModelList: visitBill })
    }).catch(error => {
      Toast.hide()
      if (typeof error === 'string') {
        Toast.fail(error, 2)
      } else {
        Toast.fail('单据获取异常')
      }
    })
  }
}
